import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';
import Immutable from 'immutable';
import CardImageHolder from '../../CardImageHolder';

const MAX_CARD_SIZE = 6;
const PAGE_SIZE = 2;
const PREFETCH_SIZE = 2;

export class CardFeedView extends Component {
  static propTypes = {
    cards: PropTypes.instanceOf(Immutable.List).isRequired,
    postPath: PropTypes.string.isRequired
  };

  constructor() {
    super();

    this.getCardPageSize = this.getCardPageSize.bind(this);

    this.renderHasCoupon = this.renderHasCoupon.bind(this);
    this.getCardTitle = this.getCardTitle.bind(this);
    this.getCardImage = this.getCardImage.bind(this);

    this.prevBtnClicked = this.prevBtnClicked.bind(this);
    this.nextBtnClicked = this.nextBtnClicked.bind(this);

    this.renderCard = this.renderCard.bind(this);

    this.state = {
      currentPage: 0,
      cardListSize: 0
    };
  }

  componentDidMount() {
    this.getCardPageSize();
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.getCardPageSize);
    }
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.getCardPageSize);
    }
  }

  getCardPageSize() {
    const container = findDOMNode(this.refs.container);
    const containerWidth = container.getBoundingClientRect().width;

    this.setState({ cardListSize: containerWidth });
  }


  getLeftPosition(viewCardSize) {
    const { cardListSize } = this.state;

    if (this.isFirstPage()) {
      return 0;
    } else if (this.isLastPage() && viewCardSize > 2) {
      return cardListSize - 620;
    } else if (this.isLastPage() && cardListSize < 380 && viewCardSize < 3) {
      return cardListSize - 425;
    }
    return -170;
  }

  isFirstPage() {
    return !this.hasPrev();
  }

  isLastPage() {
    return !this.hasNext();
  }

  hasPrev() {
    const { currentPage } = this.state;
    return currentPage > 0;
  }

  hasNext() {
    const { cards } = this.props;
    const { currentPage } = this.state;

    const cardSize = Math.min(cards.size, MAX_CARD_SIZE);

    return (currentPage + 1) * 2 < cardSize;
  }

  prevBtnClicked() {
    const { currentPage } = this.state;

    this.setState({
      currentPage: currentPage - 1
    });
  }

  nextBtnClicked() {
    const { currentPage } = this.state;

    this.setState({
      currentPage: currentPage + 1
    });
  }

  renderHasCoupon() {
    const { cards } = this.props;
    const hasCard = !!cards.find(card => card.get('type') === 'couponCard');

    if (hasCard) {
      return (
        <p className="desc_coupon">
          <span className="ico_plus" />
          <em className="txt_coupon">쿠폰</em>이 포함된 컨텐츠입니다.
        </p>
      );
    }
    return null;
  };


  getCardTitle(card) {
    if (card.type === 'couponCard') {
      return card.coupon.title;
    }
    return card.title;
  };

  getCardImage(card) {
    if (card.type === 'couponCard') {
      return card.coupon.entryImage;
    }
    return card.medium;
  };

  renderCard(viewCards, moreCount, card, idx) {
    const { postPath } = this.props;

    const isLast = idx + 1 === Math.min(viewCards.size, MAX_CARD_SIZE)
      && !this.hasNext() && moreCount > 0;

    return (
      <li key={idx}>
        <a href={postPath} className="card_default">
          <div className="inner_card">
            <div className="wrap_thumb" style={{ borderRadius: '3px 3px 0 0' }}>
              <CardImageHolder image={this.getCardImage(card)}
                cardWidth={190} cardHeight={190} isVertical={card.type === 'verticalCard'}
                noGifBlur
                noFrame
              />
              {
                isLast &&
                  <span className="num_count">{`+${moreCount}`}<span className="screen_out">개 더보기</span></span>
              }
            </div>
            <div className="info_cont">
              <strong className="tit_card">{isLast ? '컨텐츠 더보기' : this.getCardTitle(card)}</strong>
            </div>
          </div>
        </a>
      </li>
    );
  }

  render() {
    const { cards, postPath } = this.props;
    const { currentPage } = this.state;

    const viewCards = cards.take(MAX_CARD_SIZE)
      .skip(currentPage * PAGE_SIZE - 1)
      .take(PAGE_SIZE + (PREFETCH_SIZE * 2));

    const moreCount = cards.size -  Math.min(cards.size, MAX_CARD_SIZE);

    if (cards.size === 1) {
      return (
        <div>
          <div className="post_card card_single" ref="container">
            <a href={postPath} className="card_default">
              <div className="inner_card">
                <div className="wrap_thumb" style={{ borderRadius: '3px 3px 0 0' }}>
                  <CardImageHolder image={this.getCardImage(cards.first())}
                    noGifBlur isFeed isVertical={cards.first().type === 'verticalCard'}
                  />
                </div>
                <div className="info_cont">
                  <strong className="tit_card">{this.getCardTitle(cards.first())}</strong>
                </div>
              </div>
            </a>
          </div>
          {this.renderHasCoupon()}
        </div>
      );
    } else {
      return (
        <div>
          <div className="post_card card_multi" ref="container">
            <ul className="list_card" style={{ width: 1300, marginLeft: this.getLeftPosition(viewCards.size) }}>
              {
                viewCards.map((card, idx) =>
                  this.renderCard(cards, moreCount, card,
                    currentPage * PAGE_SIZE + idx - (this.hasPrev() ? 1 : 0))
                )
              }
            </ul>
            <div className="paging_card">
              <button type="button"
                className={`btn_paging btn_prev ${this.hasPrev() ? '' : 'hide'}`}
                onClick={this.prevBtnClicked}
              >
                <span className="ico_plus">이전</span>
              </button>
              <button type="button"
                className={`btn_paging btn_next ${this.hasNext() ? '' : 'hide' }`}
                onClick={this.nextBtnClicked}
              >
                <span className="ico_plus">다음</span>
              </button>
            </div>
          </div>
          {this.renderHasCoupon()}
        </div>
      );
    }
  }
}

export default CardFeedView;



// WEBPACK FOOTER //
// ./src/components/PostBox/FeedView/CardFeedView.js